import { z } from 'zod';
import { LOCALES, PAGINATION, SLUG_PATTERN, PHONE_PATTERN } from '../constants/index.js';
/**
 * Uch tilli matn. Loyihadagi BARCHA tarjima qilinadigan maydon shu tipda
 * bo'lishi shart (CLAUDE.md §4).
 *
 * @param opts.required — `uz` maydoni bo'sh bo'lmasligi kerakmi.
 *   `ru`/`en` hech qachon majburiy emas: to'ldirilmasa `uz` ga fallback bo'ladi.
 */
/**
 * Uch tilli matn — IXTIYORIY maydon uchun.
 *
 * Butun obyekt `.default()` ga ega: sxemada maydon ko'rsatilmasa
 * `{uz:'', ru:'', en:''}` bo'ladi. Bu 31 blok va barcha entity sxemalarida
 * har bir tarjima maydoniga qo'lda default yozishdan qutqaradi.
 */
export const translatableString = (opts = {}) => {
    const max = opts.max ?? 100_000;
    const base = z.string().trim().max(max);
    return z
        .object({ uz: base.default(''), ru: base.default(''), en: base.default('') })
        .default({ uz: '', ru: '', en: '' });
};
/**
 * Uch tilli matn — MAJBURIY maydon uchun (`uz` bo'sh bo'la olmaydi).
 * Sahifa sarlavhasi, mahsulot nomi kabi kontent uchun.
 *
 * `ru`/`en` baribir ixtiyoriy: to'ldirilmasa saytda `uz` ko'rsatiladi
 * (docs/03-CONVENTIONS.md §6).
 */
export const requiredTranslatable = (opts = {}) => {
    const max = opts.max ?? 100_000;
    const base = z.string().trim().max(max);
    return z.object({
        uz: base.min(1, 'O‘zbekcha matn majburiy'),
        ru: base.default(''),
        en: base.default(''),
    });
};
export const localeSchema = z.enum(LOCALES);
/**
 * Barcha maydonlari default qiymatga ega sxemadan `.default()` yasaydi.
 *
 * Nima uchun kerak: `schema.default({})` ishlamaydi — Zod `.default()` ga
 * sxemaning CHIQISH tipini kutadi, `{}` esa unga mos kelmaydi. Bu yordamchi
 * bo'sh obyektni sxemaning o'zi orqali parse qilib to'liq default hosil qiladi.
 */
export const defaulted = (schema) => schema.default(() => schema.parse({}));
/** MongoDB ObjectId — 24 ta hex belgi. */
export const objectIdSchema = z.string().regex(/^[0-9a-fA-F]{24}$/, 'Noto‘g‘ri identifikator');
export const slugSchema = z
    .string()
    .trim()
    .min(1)
    .max(160)
    .regex(SLUG_PATTERN, 'Slug faqat kichik lotin harflari, raqam va defisdan iborat bo‘lishi kerak');
/**
 * Kirish sxemalari uchun slug: BO'SH bo'lishi mumkin.
 *
 * Bo'sh bo'lsa server uni sarlavhadan yasaydi. Bo'shdan boshqa har qanday
 * qiymat baribir slug qoidasiga bo'ysunadi — «Yangi sahifa» kabi matn
 * manzilga tushib qolmasin.
 */
export const optionalSlugSchema = z.union([z.literal(''), slugSchema]).default('');
export const phoneSchema = z
    .string()
    .trim()
    .regex(PHONE_PATTERN, 'Telefon +998XXXXXXXXX ko‘rinishida bo‘lishi kerak');
/** Narx: butun son, UZS. `null` → «Narxni so'rang» (ADR-004). */
export const priceSchema = z
    .number()
    .int('Narx butun son bo‘lishi kerak')
    .nonnegative('Narx manfiy bo‘la olmaydi')
    .max(1_000_000_000_000)
    .nullable();
export const mediaRefSchema = z.object({
    mediaId: objectIdSchema,
    alt: translatableString().nullable().default(null),
});
export const seoMetaSchema = z.object({
    metaTitle: translatableString({ max: 200 }),
    metaDescription: translatableString({ max: 400 }),
    ogImage: mediaRefSchema.nullable().default(null),
    canonicalUrl: z.string().url().nullable().default(null),
    noIndex: z.boolean().default(false),
});
/** Ro'yxat so'rovlarining umumiy qismi. */
export const paginationQuerySchema = z.object({
    page: z.coerce
        .number()
        .int()
        .min(1)
        .max(PAGINATION.MAX_PAGE, `Maksimal sahifa — ${PAGINATION.MAX_PAGE}`)
        .default(PAGINATION.DEFAULT_PAGE),
    limit: z.coerce.number().int().min(1).max(PAGINATION.MAX_LIMIT).default(PAGINATION.DEFAULT_LIMIT),
});
export const langQuerySchema = z.object({
    lang: localeSchema.optional(),
});
//# sourceMappingURL=common.js.map